/***
 * 创建人：段锐
 * 时间：2019-06-10
 * 描述：对座机进行验证
 * 更新记录: 
 */
import { Directive} from "@angular/core"
import { Validator, AbstractControl, NG_VALIDATORS} from "@angular/forms"

@Directive({
  selector:"[validateFixPhone]",
  providers:[{provide:NG_VALIDATORS,useExisting:ValidatorPhoneDirective,multi:true}]
})
export class ValidatorPhoneDirective implements Validator{
  constructor(){

  }
  validate(control:AbstractControl):{[property:string]:string}{
      let reg=/^0\d{2}-\d{7,8}$/; //正则表达式
      let phone=control.value;//文本框的值

      if(!phone || phone==""){ //为空时不验证
        return null
      }
       if(reg.test(phone)){
          return null
       }else{
          return {ValidateFixPhone:"座机格式不匹配"}
       }    
  }
}